import { createFileRoute } from "@tanstack/react-router"

import ContractPage from "@/features/static/components/contract"

export const Route = createFileRoute("/_screen/contract")({
  component: Contract
})

function Contract() {
  return <ContractPage />
}
